import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  (theme) => ({
    root: {
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    main: {
      height: 68,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    left: {
      flex: 1,
    },
    logo: {
      width: 85,
      marginLeft: 15,
    },
    menuIconButton: {
      padding: 0,
    },
    menuIcon: {
      margin: [0, 12, 0, 15],
      fontSize: theme.typography.pxToRem(32),
    },
    searchIcon: {
      fontSize: theme.typography.pxToRem(32),
    },
    buttonLink: {
      marginLeft: 14,
      height: 24,
      color: theme.palette.primary.light,
      border: [1, "solid", theme.palette.secondary.main],
      display: "block",
      padding: [0, 12],
      borderRadius: 12,
      willChange: "backgroundColor",
      transform: "opacity 0.1s cubic-bezier(0.25, 1, 0.5, 1)",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    buttonLinkActive: {
      "& span": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
  }),
  { name: "MobileHeader" },
);
